<template lang="pug">
transition-group(
  tag="span",
  name="expand",
  @enter="enter",
  @after-enter="afterEnter",
  @leave="leave"
)
  slot
</template>

<script>
export default {
  name: "Expand",
  methods: {
    enter(element) {
      const width = getComputedStyle(element).width;

      element.style.width = width;
      element.style.position = "absolute";
      element.style.visibility = "hidden";
      element.style.height = "auto";

      const height = getComputedStyle(element).height;

      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;

      getComputedStyle(element).height;

      requestAnimationFrame(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
    leave(element) {
      const height = getComputedStyle(element).height;

      element.style.height = height;

      getComputedStyle(element).height;

      requestAnimationFrame(() => {
        element.style.height = 0;
      });
    },
  },
};
</script>

<style scoped lang="scss">
span {
  display: block;

  &::v-deep {
    & > * {
      will-change: height;
      transform: translateZ(0);
      backface-visibility: hidden;
      perspective: 1000px;
      transition: height 350ms ease, opacity 350ms ease;
    }
    .expand-enter-active,
    .expand-leave-active {
      overflow: hidden;
    }

    .expand-enter-from,
    .expand-leave-to {
      height: 0;
      opacity: 0;
    }
  }
}
</style>
